






























































import { Component, Vue } from "vue-property-decorator";
import OrganizationModel from "@/model/Organization";
import OrganizationApi from "@/api/Organization";
import ModelFactory from "@/model/ModelFactory";

import { namespace } from "vuex-class";
import ReportModel from "@/model/Report";
import ReportApi from "@/api/Report";
import ReportAdmin from "@/components/Report/ReportAdmin.vue";

import OrganizationLink from "./OrganizationLink.vue";
import OrganizationList from "./OrganizationList.vue";

const AppStore = namespace("App");
const UserStore = namespace("User");
const FormStore = namespace("Form");

@Component({
  name: "Organization",
  components: {
    ReportAdmin,
    OrganizationLink,
    OrganizationList
  }
})
export default class Organization extends Vue {
  public organizations: OrganizationModel[] = [];
  public selectedOrganization: string | number = "";
  public report: ReportModel = ModelFactory.create("ReportModel");

  @AppStore.State
  public reportYear!: number;

  @AppStore.State
  public canPublishReport!: boolean;

  @UserStore.Getter
  public isAdmin!: boolean;

  @UserStore.Getter
  public getOrganization!: string;

  @FormStore.State
  public formDisabled!: boolean;

  mounted() {
    const year = this.reportYear;
    this.$store.commit("App/setPageTitle", this.organizationName);
    this.$store.commit("App/setPageDescription", `Raport za rok ${year}`);
    this.getOrganizations();
  }

  get organizationName() {
    return (this.$store.state.App.organizations as any)[this.getOrganization];
  }

  get isReportSent() {
    return this.report.status === "current";
  }

  async getOrganizations(organizationId?: number | string) {
    if (!organizationId) {
      organizationId = this.selectedOrganization;
    }
    this.selectedOrganization = organizationId;

    const organizations = await OrganizationApi.getList(organizationId).then(
      (organizations: OrganizationModel[] | undefined) => organizations
    );
    const report = await ReportApi.get(organizationId).then(
      (report: any) => report
    );

    this.organizations = ModelFactory.create(
      "OrganizationModel",
      organizations
    );
    this.report = ModelFactory.create("ReportModel", report);

    const disabled =
      this.report.status == "current" ||
      this.getOrganization !== this.report.organization;
    //(this.report.id > 0 && this.getOrganization !== this.report.organization);

    this.$store.commit("Form/setDisabled", disabled);
  }

  unlockRequest() {
    return ReportApi.unlockRequest(this.report.id);
  }

  async unlock() {
    const unlocked = await ReportApi.unlock(this.report.id).then(
      (res: ServerResponse) => res.success
    );

    if (unlocked) {
      this.getOrganizations();
    }
  }
}
